export default __webpack_public_path__ + "static/media/fet_diagram.2ace3f3b.png";